module.exports = __webpack_public_path__ + "static/img/left-home-row-1.f81afc7d.png";